module.exports = __webpack_public_path__ + "img/5.787f5910.png";